var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpprticon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 14,
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1210_24845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.9999H69.0001V67H19V16.9999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1210_24845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5678 56.7769V63.7644C61.5678 64.1512 61.3404 64.5019 60.9872 64.6596L57.5771 66.1823C57.3226 66.296 57.0318 66.296 56.7774 66.1823L53.1865 64.5788C52.932 64.4652 52.6413 64.4652 52.3868 64.5788L48.7961 66.1823C48.5416 66.296 48.2508 66.296 47.9963 66.1823L44.4059 64.5788C44.1514 64.4652 43.8606 64.4652 43.6061 64.5788L40.0157 66.1823C39.7613 66.296 39.4705 66.296 39.216 66.1823L35.6256 64.5788C35.3711 64.4652 35.0803 64.4652 34.8258 64.5788L31.2353 66.1823C30.9809 66.296 30.69 66.296 30.4356 66.1823L27.0259 64.6596C26.6728 64.5019 26.4453 64.1513 26.4453 63.7644V19.1505C26.4453 18.4403 27.1771 17.9657 27.8256 18.2554L30.4356 19.421C30.69 19.5347 30.9809 19.5347 31.2353 19.4211L34.8258 17.8176C35.0803 17.7039 35.3711 17.7039 35.6256 17.8176L39.216 19.4211C39.4705 19.5347 39.7613 19.5347 40.0157 19.421L43.6061 17.8176C43.8606 17.7039 44.1514 17.7039 44.4059 17.8176L47.9963 19.4211C48.2508 19.5347 48.5416 19.5347 48.7961 19.4211L52.3868 17.8176C52.6413 17.7039 52.932 17.7039 53.1865 17.8176L56.7774 19.4211C57.0318 19.5347 57.3226 19.5347 57.5771 19.4211L60.1875 18.2554C60.8361 17.9657 61.5678 18.4403 61.5678 19.1504V53.359",
    stroke: "#AD49E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3001 39.5369C51.3001 39.1036 51.2605 38.6793 51.1854 38.2672C51.1602 38.1294 51.2279 37.9913 51.3515 37.9213L52.3058 37.3804C52.4693 37.2876 52.5254 37.0822 52.431 36.9217L50.5266 33.6834C50.4321 33.5227 50.2229 33.4677 50.0593 33.5604L49.1042 34.1018C48.9806 34.1719 48.8246 34.1603 48.7156 34.0699C48.0587 33.5242 47.302 33.0907 46.4764 32.7992C46.3423 32.7518 46.2545 32.625 46.2545 32.4849V31.4039C46.2545 31.2183 46.1013 31.068 45.9124 31.068H42.1036C41.9146 31.068 41.7615 31.2183 41.7615 31.4039V32.4849C41.7615 32.625 41.6736 32.7518 41.5394 32.7992C40.7138 33.0907 39.9572 33.5242 39.3004 34.0699C39.1913 34.1603 39.0354 34.1719 38.9118 34.1018L37.9566 33.5604C37.793 33.4677 37.5838 33.5227 37.4893 33.6834L35.5849 36.9217C35.4905 37.0822 35.5466 37.2876 35.7101 37.3804L36.6644 37.9213C36.788 37.9913 36.8557 38.1294 36.8306 38.2672C36.7553 38.6793 36.7158 39.1036 36.7158 39.5369C36.7158 39.9703 36.7553 40.3945 36.8306 40.8066C36.8557 40.9445 36.788 41.0826 36.6644 41.1526L35.7101 41.6935C35.5466 41.7862 35.4905 41.9917 35.5849 42.1522L37.4893 45.3904C37.5838 45.5512 37.793 45.6061 37.9566 45.5134L38.9118 44.972C39.0354 44.9019 39.1913 44.9135 39.3004 45.004C39.9572 45.5496 40.7138 45.9831 41.5395 46.2746C41.6736 46.322 41.7615 46.4489 41.7615 46.589V47.67C41.7615 47.8555 41.9146 48.0059 42.1036 48.0059H45.9124C46.1013 48.0059 46.2545 47.8555 46.2545 47.67V46.589C46.2545 46.4489 46.3423 46.322 46.4765 46.2746C47.3021 45.9831 48.0587 45.5496 48.7156 45.004C48.8246 44.9135 48.9806 44.9019 49.1042 44.972L50.0593 45.5134C50.2229 45.6061 50.4321 45.5512 50.5266 45.3904L52.431 42.1522C52.5254 41.9917 52.4693 41.7862 52.3058 41.6935L51.3515 41.1526C51.2279 41.0826 51.1602 40.9445 51.1854 40.8066C51.2605 40.3945 51.3001 39.9703 51.3001 39.5369Z",
    stroke: "#AD49E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0406 39.5368C48.0406 41.7251 46.2337 43.499 44.0047 43.499C41.7757 43.499 39.9688 41.7251 39.9688 39.5368C39.9688 37.3486 41.7757 35.5747 44.0047 35.5747C46.2337 35.5747 48.0406 37.3486 48.0406 39.5368Z",
    stroke: "#AD49E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3131 23.4936H54.8477C55.2252 23.4936 55.5313 23.7997 55.5313 24.1772V26.3257C55.5313 26.7032 55.2252 27.0093 54.8477 27.0093H33.168C32.7904 27.0093 32.4844 26.7032 32.4844 26.3257V24.1772C32.4844 23.7997 32.7904 23.4936 33.168 23.4936H36.8951",
    stroke: "#AD49E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 51.894H55.5313",
    stroke: "#AD49E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 56.2886H55.5313",
    stroke: "#AD49E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 60.6831H48.2071",
    stroke: "#AD49E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpprticon1);
export default __webpack_public_path__ + "static/media/spprticon1.21f370c36373398abd905e734a266da7.svg";
export { ForwardRef as ReactComponent };